import React from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../auth/useAuth.js";

export default function Header() {
  const { user, isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <header className="site-header">
      <div className="site-header__inner">
        <div className="site-header__brand">
          A<span>History</span>
        </div>
        <nav className="site-header__tabs">
          <NavLink
            to="/car"
            className={({ isActive }) => `tab-link${isActive ? " active" : ""}`}
          >
            Car Details
          </NavLink>
          <NavLink
            to="/history"
            className={({ isActive }) => `tab-link${isActive ? " active" : ""}`}
          >
            History
          </NavLink>
          <NavLink
            to="/plugin"
            className={({ isActive }) => `tab-link${isActive ? " active" : ""}`}
          >
            Plugin
          </NavLink>
        </nav>
        <div className="site-header__spacer" />
        <div className="site-header__user">
          {isAuthenticated ? (
            <>
              <span>
                Logged in as <b>{user?.name || user?.email || `#${user?.id}`}</b>
              </span>
              <button className="btn btn-ghost" onClick={logout}>
                Log out
              </button>
            </>
          ) : (
            <button
              className="btn"
              onClick={() =>
                navigate("/login", { state: { from: location.pathname } })
              }
            >
              Log in
            </button>
          )}
        </div>
      </div>
    </header>
  );
}
